<template>
  <div class="k3l-table-container">
    <b-table striped bordered responsive no-border-collapse :items="getK3lData" :fields="fields">
    </b-table>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'k3l',
  props: {
    detailId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dateFormat: { day: 'numeric', month: 'short', year: 'numeric' },
      items: [
        { score: '75', start_date: 1576067992682, end_date: 1576067992682}
      ],
      fields: [
        { key: 'score', label: 'Score for K3L Prequalification (%)', thClass: 'bg-head' },
        { key: 'start_date', label: 'Tanggal Mulai Prequalification', thClass: 'bg-head' },
        { key: 'end_date', label: 'Tanggal Akhir Prequalification', thClass: 'bg-head' },
      ]
    }
  },
  methods: {
    getK3lData(){
      const self = this
      const supplierInfo = self.$store.state.datatable.detail
      if(supplierInfo){
        let k3lData = [{
          score : Number(supplierInfo['SCORE_FOR_K3L_PREQUALIFICATION']).toFixed(0),
          start_date : self.formatDate(supplierInfo['K3L_PREQ_START_DATE']),
          end_date : self.formatDate(supplierInfo['K3L_PREQ_END_DATE'])
        }]
        return k3lData
      }
    },
    formatDate(value){
      if(value && moment(value).isValid()){
        return moment(value).format('DD MMM YYYY')
      }
      return '-'
    }
  },
}
</script>
<style lang="scss">
  @import "~/assets/scss/components/k3ldetail.scss";
</style>
